// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GameChanceCard_container__uW1ig {
  background-color: #015551;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 16px;
  border: 1px solid rgba(250, 247, 228, 0.24);
  padding: 8px;
  min-width: 48%;
}

.GameChanceCard_icon__z1cTB {
  width: 24px;
  height: 24px;
  margin-left: 6px;
}

.GameChanceCard_title__4QLqn {
  color: #fcfaee;
  font-size: 14px;
  font-weight: 450;
}

.GameChanceCard_desc__SlGdN {
  color: #fcfaee;
  font-size: 10px;
  font-weight: 300;
  margin-top: 8px;
}

.GameChanceCard_chance__gnLO0 {
  color: #fcfaee;
  font-size: 10px;
  font-weight: 600;
  margin-top: 12px;
}

.GameChanceCard_button__5FYn1 {
  height: 44px;
  padding: 10px;
  border: 1px solid #ff392d;
  margin-top: 8px;
}
.GameChanceCard_button__5FYn1 span {
  font-size: 14px;
}

@media screen and (min-width: 1200px) {
  .GameChanceCard_title__4QLqn {
    font-size: 16px;
  }
  .GameChanceCard_desc__SlGdN {
    font-size: 12px;
  }
  .GameChanceCard_chance__gnLO0 {
    font-size: 12px;
  }
  .GameChanceCard_button__5FYn1 span {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/GameChanceCard/GameChanceCard.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".container {\n  background-color: #015551;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-radius: 16px;\n  border: 1px solid rgba(250, 247, 228, 0.24);\n  padding: 8px;\n  min-width: 48%;\n}\n\n.icon {\n  width: 24px;\n  height: 24px;\n  margin-left: 6px;\n}\n\n.title {\n  color: #fcfaee;\n  font-size: 14px;\n  font-weight: 450;\n}\n\n.desc {\n  color: #fcfaee;\n  font-size: 10px;\n  font-weight: 300;\n  margin-top: 8px;\n}\n\n.chance {\n  color: #fcfaee;\n  font-size: 10px;\n  font-weight: 600;\n  margin-top: 12px;\n}\n\n.button {\n  height: 44px;\n  padding: 10px;\n  border: 1px solid #ff392d;\n  margin-top: 8px;\n}\n.button span {\n  font-size: 14px;\n}\n\n@media screen and (min-width: 1200px) {\n  .title {\n    font-size: 16px;\n  }\n  .desc {\n    font-size: 12px;\n  }\n  .chance {\n    font-size: 12px;\n  }\n  .button span {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GameChanceCard_container__uW1ig`,
	"icon": `GameChanceCard_icon__z1cTB`,
	"title": `GameChanceCard_title__4QLqn`,
	"desc": `GameChanceCard_desc__SlGdN`,
	"chance": `GameChanceCard_chance__gnLO0`,
	"button": `GameChanceCard_button__5FYn1`
};
export default ___CSS_LOADER_EXPORT___;
